import { get } from 'lodash';
let animationMap = {}; // item with same offset have different enter offset
const animationDelta = 0.25;

function getDate(date, lang) {
  if (date){
    let months = {
      "it": ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
      "en": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };
    let d = new Date(date);
    return {
      "day": d.getDate(),
      "month": months[lang][d.getMonth()],
      "year": d.getFullYear(),
      "hours": d.getHours(),
      "minutes": d.getMinutes(),
      "seconds": d.getSeconds(),
      "postfix": d.getDate()%10 == 1 ? "st": d.getDate()%10 == 2 ? "nd" : d.getDate()%10 == 3 ? "rd" : "th",
    };
  }
}

function registerAnimation() {
  $(this.$el).one('inview', function(event, isInView) {
    if (isInView) {
      const elOffset = Math.trunc($(event.target).offset().top);

      if (animationMap[elOffset]) {
        animationMap[elOffset] = animationMap[elOffset] + animationDelta;
        setTimeout(() => { // reset offset
          delete animationMap[elOffset];
        }, 1000);
      } else {
        animationMap[elOffset] = animationDelta;
      }

      $(event.target).css({"-webkit-animation-delay": `${animationMap[elOffset]}s`, "animation-delay": `${animationMap[elOffset]}s`});

      const animationClass = $(event.target).attr("animation-class") || "inview_animate_in";
      $(event.target).addClass(animationClass);
    }
  });
}

function isTypeformScriptInContentButtons(content) {
  let result = content.button && HfarmCorporate.isTypeformUrl(content.button.url);

  if (content.buttons) {
    content.buttons.forEach(buttonRecord => {
      if (buttonRecord.button && isTypeformUrl(buttonRecord.button.url)) {
        result = true;
      } 
    });
  }

  return result;
}

function initTypeformScript(forceExecution) {
  console.log("TypeForm script added in page");
  const init = () => {
    let qs,js,q,s,d = document, gi=d.getElementById, ce=d.createElement, gt=d.getElementsByTagName, id="typef_orm", b="https://embed.typeform.com/"; 
    if (!gi.call(d,id)) {
      js=ce.call(d,"script");
      js.id=id;
      js.src=b+"embed.js";
      q=gt.call(d,"script")[0];
      q.parentNode.insertBefore(js,q);
    }
  }
  if (!!forceExecution) {
    init();
  } else {
    Fandom.executeOnce("type-form", init);
  }
}

function zohoInitScript(url, divId) {
  ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach(key => {
    const value = Fandom.getUrlParameter(key);
    if (value) {
      url = Fandom.updateQueryStringParameter(url, key, value);
    }
  });

  try{
    var f = document.createElement("iframe");
    f.src = encodeURI(url);
    f.style.border="none";
    f.style.height=(`${window.innerHeight - 128}px`);
    f.style.width="100%";
    f.style.transition="all 0.5s ease";// No I18N
    var d = document.getElementById(divId);
    d.appendChild(f);
    window.addEventListener('message', function (){
      var zf_ifrm_data = !!get(event, 'data', '').split ? get(event, 'data', '').split("|") : [];
      var zf_perma = zf_ifrm_data[0];
      var zf_ifrm_ht_nw = ( parseInt(zf_ifrm_data[1], 10) + 15 ) + "px";
      var iframe = document.getElementById(divId).getElementsByTagName("iframe")[0];
      if ( (iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0 ) {
        var prevIframeHeight = iframe.style.height;
        if ( prevIframeHeight != zf_ifrm_ht_nw ) {
          iframe.style.height = zf_ifrm_ht_nw;
        }
      }
    }, false);
  } catch(e){}
}

function isTypeformUrl(url) {
  if (!!url && typeof url == "string") {
    return url.includes('typeform');
  } else {
    return false;
  }
}

function isZohoUrl(url) {
  if (!!url && typeof url == "string") {
    return url.includes('forms.zohopublic.eu');
  } else {
    return false;
  }
}

function getZohoDivId(content) {
  return `zoho_form_${JSON.stringify(content).split('').map(c => c.charCodeAt(0)).join('')}`;
}

const HfarmCorporate = {
  registerAnimation,
  initTypeformScript,
  isTypeformUrl,
  isTypeformScriptInContentButtons,
  getDate,
  isZohoUrl,
  zohoInitScript,
  getZohoDivId
};

export { HfarmCorporate };
